<button (click)="onButtonClick($event)" [disabled]="isLoading">{{title}}
  <img *ngIf="isLoading" src="assets/gifs/spinner.gif"/>
</button>

